import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../utils/router";
import { debounce } from "lodash";
import queryString from "query-string";

import { downloadFile, postRequest, request, withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../general/Loader";
import { apiUrl } from "../../utils/apiUrl";
import { auth } from "../../utils/auth";
import { getLink, getVendedoresForDropdown, toast } from "../../utils/helpers";
import EstadosCuentaForm from "./EstadoCuentasForm";
import AsignarVendedorForm from "./AsignarVendedorForm";
import Select from "react-select";

const queryDeFiltros = (filtros) =>
	Object.keys(filtros)
		.map((fil) => `${fil}=${filtros[fil]}`)
		.join("&");

const puedeAsignarVendedor = () => auth.is("super-admin") || auth.is("admin");

class Contactos extends Component {
	state = {
		activo: {},
		contactos: [],
		contacto: {},
		links: null,
		loading: true,
		showCreate: false,
		showEdit: false,
		showSidePopup: false,
		showDelete: false,
		showEstadoDeCuentaModal: false,
		rutasForDropdown: [],
		vendedoresForDropdown: [],
		terminosForDropdown: [],
		numeraciones: [],
		showCXCButton: false,
		showCXPButton: false,
		loadingPDF: false,
		seleccionados: [],
		seleccionarTodos: false,
		showAsignarVendedor: false,
	};
	constructor(props) {
		super(props);
		this.sidePopupWrap = React.createRef();
		this.sidePopupOverlay = React.createRef();
	}
	componentDidMount() {
		this.getContactos();
		this.getRutas();
		this.getVendedores();
		this.getTerminosData("terminos-pago?limit=100");
		this.getNumeraciones();
		const params = queryString.parse(window.location.search);
		if (params.id !== undefined) {
			this.onFiltroChange(params.id, "buscar");
			this.setState({
				activo: params.id,
			});
		}
        if (typeof params.crear_contacto !== 'undefined') {
            this.toggleCreateModal();
        }
	}
	getNumeraciones = async () => {
        request('numeracion-documentos?tipo_documento=factura_venta').then((response) => {
            this.setState({ numeraciones: response.data });
        });
    }
	getContactos = async (url = null) => {
		url = url ? url + "&limit=20" : "contactos?limit=20";
		const contactos = await this.props.request(url);

		if (contactos.data) {
			this.setState({
				contactos: contactos.data,
				links: contactos.links,
				meta: contactos.meta,
				loading: false,
			});
		}
	};
	getTieneCuenta = async (id) => {
		if (id) {
			const url = `contactos/${id}/tieneCuentas`;
			const tieneCuenta = await this.props.request(url);

			if (tieneCuenta.data) {
				this.setState({
					showCXCButton: tieneCuenta.data.cxc,
					showCXPButton: tieneCuenta.data.cxp,
				});
			}
		}
	};
	// `await this.setState()` no espera al re-render: setState no devuelve una
	// promesa, así que la continuación se reanudaba antes de que React
	// aplicara el update y `this.state.filtros` tenía los filtros anteriores.
	// Por eso cada consulta salía un filtro atrás y el primer intento no
	// filtraba nada. El estado se actualiza con la forma funcional y la consulta
	// se lanza en el callback de setState, que sí corre después del commit.
	onFiltroChange = (value, filtro) => {
		// La selección corresponde a la lista anterior: con otro filtro ya no
		// se sabe qué ve el usuario.
		this.setState(
			(state) => ({
				filtros: { ...state.filtros, [filtro]: value },
				seleccionados: [],
				seleccionarTodos: false,
			}),
			this.buscarConFiltros
		);
	};
	// El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
	// era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
	// descartaba el primero junto con su valor.
	buscarConFiltros = debounce(() => {
		this.getContactos(
			"contactos?limit=20&" + queryDeFiltros(this.state.filtros)
		);
	}, 500);
	toggleCreateModal = () => {
		this.setState({
			showCreate: !this.state.showCreate,
			contacto: {},
		});
	};
	toggleEditModal = (contacto) => {
		this.setState({
			showEdit: !this.state.showEdit,
			contacto: contacto,
		});
	};
	changeItem = (activo) => {
		this.setState({
			activo,
		});
		this.getTieneCuenta(activo);
		this.toggleSidePopup(true);
	};
	toggleSidePopup = (show) => {
		if (!show) {
			this.sidePopupWrap.current.classList.remove("slideInRight");
			this.sidePopupWrap.current.classList.add("slideOutRight");
			this.sidePopupOverlay.current.classList.remove("fadeIn");
			this.sidePopupOverlay.current.classList.add("fadeOut");
			setTimeout(() => {
				this.setState({
					showSidePopup: show,
				});
			}, 1000);
			this.setState({
				showCXCButton: false,
				showCXPButton: false,
			});
			return;
		}

		this.setState({
			showSidePopup: true,
		});
	};
	deleteContacto = async (contacto) => {
		this.toggleSidePopup(false);

		const url = `contactos/${contacto}`;
		const response = await postRequest(apiUrl(url), {}, 'delete');

		if (response.success) {
			this.toggleDeleteModal();
			this.getContactos();
			toast("Contacto borrado.");
			return;
		} else {
			toast(response.data, "error");
		}
	};
	toggleDeleteModal = () => {
		this.setState((state) => ({ ...state, showDelete: !state.showDelete }));
	};
	toggleEstadoDeCuentaModal = () => {
		this.setState((state) => ({ ...state, showEstadoDeCuentaModal: !state.showEstadoDeCuentaModal }));
	};
	getRutas = async (url = null) => {
		url = url ? url + "&limit=1000" : "rutas?limit=1000";
		const rutas = await this.props.request(url);
		if (rutas.links) {
			this.setState({
				rutasForDropdown: rutas.data.map((ruta) => ({
					value: ruta.id,
					label: ruta.nombre,
				})),
			});
		}
	};
	getVendedores = async (url = null) => {
		getVendedoresForDropdown().then((data) => {
			this.setState({
				vendedoresForDropdown: [...data, { value: 'sin vendedor', label: 'Sin Vendedor' }],
			});
		});
	};
	getTerminosData = async (url = null) => {
		url = url ? url + "&limit=15" : "terminos-pago?limit=15";

		const terminos = await this.props.request(url);
		if (terminos.links) {
			this.setState({
				terminosForDropdown: terminos.data.map((termino) => ({
					value: termino.id,
					label: termino.nombre,
				})),
			});
		}
	};
	toggleSeleccion = (id) => {
		this.setState((state) => ({
			seleccionarTodos: false,
			seleccionados: state.seleccionados.includes(id)
				? state.seleccionados.filter((seleccionado) => seleccionado !== id)
				: [...state.seleccionados, id],
		}));
	};
	toggleSeleccionPagina = () => {
		this.setState((state) => {
			const ids = state.contactos.map((contacto) => contacto.id);
			const todaLaPagina = ids.every((id) => state.seleccionados.includes(id));

			return {
				seleccionarTodos: false,
				seleccionados: todaLaPagina
					? state.seleccionados.filter((id) => !ids.includes(id))
					: [...new Set([...state.seleccionados, ...ids])],
			};
		});
	};
	limpiarSeleccion = () => {
		this.setState({ seleccionados: [], seleccionarTodos: false });
	};
	toggleAsignarVendedorModal = () => {
		this.setState((state) => ({ showAsignarVendedor: !state.showAsignarVendedor }));
	};
	onVendedorAsignado = () => {
		this.setState({ showAsignarVendedor: false, seleccionados: [], seleccionarTodos: false });
		this.getContactos("contactos?limit=20&" + queryDeFiltros(this.state.filtros ?? {}));
	};
	exportPdf = async () => {
		if (this.state.loadingPDF) return;

		this.setState({loadingPDF: true});

		const query = Object.keys(this.state.filtros ?? {}).map((fil) => {
			return `${fil}=${this.state.filtros[fil]}`;
		});

		const url = `contactos/export/pdf?${query.join("&")}`;

		await downloadFile(url, 'reporte.pdf');

		this.setState({loadingPDF: false});
	};
	render() {
		const {
			contactos,
			showSidePopup,
			activo,
			loading,
			rutasForDropdown,
			vendedoresForDropdown,
			terminosForDropdown,
			showCXCButton,
			showCXPButton,
			seleccionados,
			seleccionarTodos,
			meta,
		} = this.state;

		const conCheckboxes = puedeAsignarVendedor();
		const totalFiltrados = meta?.total ?? contactos.length;
		const paginaSeleccionada = contactos.length > 0
			&& contactos.every((contacto) => seleccionados.includes(contacto.id));
		const cantidadSeleccionada = seleccionarTodos ? totalFiltrados : seleccionados.length;

		const itemActivo = contactos.filter(
			(contacto) => contacto.id === activo
		)[0];

		return (
			<div>
				<div className="page-header">
					<h1 className="page-title row">
						<span className="mr-auto">Contactos</span>
						<Link to={getLink("/rutas")} className="au-btn au-btn-icon au-btn--green au-btn--small mr-1 mr-md-2 btn-xs-small">
							<i className='fas fa-map-marker-alt mr-2' />
							<span className="menu-name" style={{fontWeight: 400}}>Zonas</span>
						</Link>

						<button
							className="au-btn au-btn-icon au-btn--green au-btn--small btn-xs-small"
							onClick={this.toggleCreateModal}
						>
							
							<span className="d-md-none"><i className="zmdi zmdi-plus" /> Añadir</span>
							<span className="d-none d-md-block"><i className="zmdi zmdi-plus" /> Añadir Contacto</span>
						</button>

						{conCheckboxes && <button
							className="au-btn au-btn-icon au-btn--green au-btn--small ml-1 ml-md-2 btn-xs-small"
							onClick={this.toggleAsignarVendedorModal}
							disabled={!cantidadSeleccionada}
							title={cantidadSeleccionada ? "" : "Seleccione los contactos en la tabla"}
						>
							<i className="zmdi zmdi-account" /> Asignar Vendedor
							{cantidadSeleccionada > 0 && ` (${cantidadSeleccionada})`}
						</button>}

						{auth.is("super-admin") && <button
							className="au-btn au-btn-icon au-btn--green au-btn--small ml-1 ml-md-2 btn-xs-small"
							onClick={this.exportPdf}
							disabled={this.state.loadingPDF}
						>
							{
								this.state.loadingPDF
								? (<div style={{height: '100%', width: '100%', display: 'flex'}}><div className='small-loader lds-dual-ring lds-dual-ring-white m-auto' /></div>)
								: <> <i className="zmdi zmdi-file" /> Exportar </>
							}

						</button>}

					</h1>
				</div>
				<div className="page-controls">
					<div className="table-data__tool">
						<div className="table-data__tool-left row">
							<div className="col-md-2">
								<label>Buscar</label>
								<input
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"buscar"
										)
									}
									type="search"
									placeholder="Buscar..."
									className="form-control"
									name="buscar"
								/>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">Vendedor</label>
								<Select
									id="vendedor"
									options={vendedoresForDropdown}
									name="vendedor"
									placeholder="Todos"
									onChange={(e) =>
										this.onFiltroChange(
											e.value,
											"vendedor"
										)
									}
									styles={{
										control: (styles) => ({
											...styles,
											height: "38px",
										}),
									}}
								/>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">Tipo</label>
								<select
									className="form-control"
									name="tipo"
									id="tipo"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"tipo"
										)
									}
								>
									<option value="todos">Todos</option>
									<option value="proveedor">Proveedor</option>
									<option value="cliente">Cliente</option>
								</select>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">
									Tipo de identificación
								</label>
								<select
									className="form-control"
									name="tipo_identificacion"
									id="tipo_identificacion"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"tipo_identificacion"
										)
									}
								>
									<option value="todos">Todos</option>
									<option value="cedula">Cedula</option>
									<option value="rnc">RNC</option>
									<option value="pasaporte">Pasaporte</option>
									<option value="otro">Otro</option>
								</select>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">Plazo</label>
								<select
									className="form-control"
									name="plazo"
									id="plazo"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"plazo"
										)
									}
								>
									<option value="todos">Todos</option>
									{terminosForDropdown.map((termino) => (
										<option
											value={termino.value}
											key={termino.value}
										>
											{termino.label}
										</option>
									))}
								</select>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">Zona</label>
								<select
									className="form-control"
									name="ruta"
									id="ruta"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"ruta"
										)
									}
								>
									<option value="todos">Todos</option>
									{rutasForDropdown.map((ruta) => (
										<option
											value={ruta.value}
											key={ruta.value}
										>
											{ruta.label}
										</option>
									))}
								</select>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div>
							{loading && <Loader />}
							{!contactos.length ? (
								<div>
									{!loading && (
										<div>
											Todavía no hay contactos creados.
										</div>
									)}
								</div>
							) : (
								<div className="table-data">
									{conCheckboxes && paginaSeleccionada && !seleccionarTodos && totalFiltrados > contactos.length && (
										<div className="alert alert-info text-center py-2">
											{seleccionados.length} contactos seleccionados.{" "}
											<button type="button" className="btn btn-link p-0 align-baseline" onClick={() => this.setState({ seleccionarTodos: true })}>
												Seleccionar los {totalFiltrados} contactos que coinciden con el filtro
											</button>
										</div>
									)}
									{conCheckboxes && seleccionarTodos && (
										<div className="alert alert-info text-center py-2">
											Los {totalFiltrados} contactos que coinciden con el filtro están seleccionados.{" "}
											<button type="button" className="btn btn-link p-0 align-baseline" onClick={this.limpiarSeleccion}>
												Limpiar selección
											</button>
										</div>
									)}
									<table className="table table-data2">
										<thead>
											<tr>
												{conCheckboxes && (
													<th style={{ width: "40px" }}>
														<input
															type="checkbox"
															checked={seleccionarTodos || paginaSeleccionada}
															onChange={this.toggleSeleccionPagina}
															title="Seleccionar la página"
														/>
													</th>
												)}
												<th>Código</th>
												<th>Nombre</th>
												<th>Tipo</th>
												<th>Vendedor</th>
												<th>Telefono</th>
												<th>Celular</th>
												<th>Zona</th>
												<th>Plazo</th>
											</tr>
										</thead>
										<tbody>
											{contactos.map((contacto) => (
												<tr
													onClick={(e) => {
														e.preventDefault();
														this.changeItem(
															contacto.id
														);
													}}
													style={{
														cursor: "pointer",
													}}
													className="tr-shadow"
													key={contacto.id}
												>
													{conCheckboxes && (
														<td onClick={(e) => e.stopPropagation()}>
															<input
																type="checkbox"
																checked={seleccionarTodos || seleccionados.includes(contacto.id)}
																onChange={() => this.toggleSeleccion(contacto.id)}
															/>
														</td>
													)}
													<td>{contacto.codigo}</td>
													<td>{contacto.nombre}</td>
													<td>{contacto.tipo}</td>
													<td>{contacto.vendedor?.nombre} {contacto.vendedor?.apellido}</td>
													<td>{contacto.telefono}</td>
													<td>{contacto.celular}</td>
													<td>
														{contacto.ruta?.nombre}
													</td>
													<td>
														{contacto.plazo?.nombre}
													</td>
												</tr>
											))}
										</tbody>
									</table>
									{this.state.links && (
										<Pagination
											links={this.state.links}
											meta={this.state.meta}
											getData={this.getContactos}
										/>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				{showSidePopup && itemActivo && (
					<div className="side-popup">
						<div
							onClick={() => this.toggleSidePopup(false)}
							ref={this.sidePopupOverlay}
							className="side-popup-background animated fadeIn"
						></div>
						<div
							ref={this.sidePopupWrap}
							className="side-popup-container animated slideInRight fast"
						>
							<h2 className="d-flex">
								<div style={{width: "60%"}}>
									{itemActivo?.nombre}{" "}
								</div>
                                <div className="text-right d-flex" style={{flex: 1, justifyContent: 'flex-end', alignItems: 'center'}}>
									{showCXCButton && (<Link
                                            to={getLink(
                                                `/consultas/cuentas-por-cobrar?buscar=${itemActivo.nombre}`
                                            )}
                                            className="btn btn-outline-primary ml-2 contacto"
                                        >
                                            CXC
                                        </Link>)}
									{showCXPButton && (<Link
                                            to={getLink(
                                                `/consultas/cuentas-por-pagar?buscar=${itemActivo.nombre}`
                                            )}
                                            className="btn btn-outline-primary ml-2 contacto"
                                        >
                                            CXP
                                        </Link>)}
                        {itemActivo.tipo?.includes('Proveedor') && (
                            <button
                                onClick={this.toggleEstadoDeCuentaModal}
                                className="btn btn-outline-primary ml-2 contacto"
                            >
                                Estado de Cuenta
                            </button>
                        )}
                                    {itemActivo.tipo?.includes('Proveedor') && (
                                        <Link
                                            to={getLink(
                                                `/contactos/${itemActivo.id}/compras`
                                            )}
                                            className="btn btn-outline-primary ml-2 contacto"
                                            onClick={() => {
                                                localStorage.setItem(
                                                    "contacto",
                                                    JSON.stringify(itemActivo)
                                                );
                                            }}
                                        >
                                            Historial de Compras
                                        </Link>
                                    )}
                                    {itemActivo.tipo?.includes('Cliente') && (
                                        <button
											onClick={this.toggleEstadoDeCuentaModal}
											className="btn btn-outline-primary ml-2 contacto"
										>
											Estados de Cuenta
										</button>
                                    )}
                                    {itemActivo.tipo?.includes('Cliente') && (
                                        <Link
                                            to={getLink(
                                                `/contactos/${itemActivo.id}/transacciones`
                                            )}
                                            className="btn btn-outline-primary ml-2 contacto"
                                            onClick={() => {
                                                localStorage.setItem(
                                                    "contacto",
                                                    JSON.stringify(itemActivo)
                                                );
                                            }}
                                        >
                                            Historial de Transacciones
                                        </Link>
                                    )}
                                    <button
                                        className="btn btn-primary float-right contacto ml-2"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Edit"
                                        onClick={() => {
                                            this.toggleEditModal(itemActivo);
                                        }}
                                    >
                                        <i className="zmdi zmdi-edit" />
                                    </button>
                                </div>
							</h2>
							<br />
							<table className="table table-small contacto-info">
								<tbody>
									<tr>
										<th>Encargado</th>
										<td>{itemActivo?.encargado}</td>
									</tr>
									<tr>
										<th>Identificación Encargado</th>
										<td>
											{
												itemActivo?.identificacion_encargado
											}
										</td>
									</tr>
									<tr>
										<th>Tipo</th>
										<td>{itemActivo?.tipo}</td>
									</tr>
									<tr>
										<th>Teléfono</th>
										<td>{itemActivo?.telefono}</td>
									</tr>
									<tr>
										<th>Celular</th>
										<td>{itemActivo?.celular}</td>
									</tr>
									<tr>
										<th>Correo electrónico</th>
										<td>{itemActivo?.email}</td>
									</tr>
									<tr>
										<th>Cédula/RNC</th>
										<td>{itemActivo?.identificacion}</td>
									</tr>
									<tr>
										<th>Provincia/Municipio</th>
										<td>{itemActivo?.provincia}</td>
									</tr>
									<tr>
										<th>Dirección</th>
										<td>{itemActivo?.direccion}</td>
									</tr>
									<tr>
										<th>Limite de crédito</th>
										<td>{itemActivo?.limite_credito}</td>
									</tr>
									<tr>
										<th>Latitud, Longitud</th>
										<td>{itemActivo?.latitud_longitud}</td>
									</tr>
									<tr>
										<th>Plazo</th>
										<td>{itemActivo?.plazo?.nombre}</td>
									</tr>
									{itemActivo?.tipo?.includes("Cliente") && (
										<>
											<tr>
												<th>Zona</th>
												<td>
													{itemActivo?.ruta?.nombre}
												</td>
											</tr>
											<tr>
												<th>Vendedor</th>
												<td>
													{
														itemActivo?.vendedor
															?.nombre
													}
												</td>
											</tr>
											<tr>
												<th>Precio de venta</th>
												<td>
													Precio venta{" "}
													{itemActivo?.precio_venta}
												</td>
											</tr>
										</>
									)}
                                    <tr>
										<th>Numeración</th>
										<td>{itemActivo?.numeracion?.nombre}</td>
									</tr>
								</tbody>
							</table>
							<p className="text-right">
								<button
									type="button"
									onClick={(e) => this.toggleDeleteModal()}
									className="btn btn-danger btn-sm"
								>
									<i className="fa fa-trash-alt"></i>
								</button>
							</p>
						</div>
					</div>
				)}
				<Modal
					show={this.state.showCreate}
					blank={true}
					toggle={this.toggleCreateModal}
					size="1048px"
				>
					<Create
						toggle={this.toggleCreateModal}
						contacto={this.state.contacto}
						getContactos={this.getContactos}
					/>
				</Modal>
				<Modal
					show={this.state.showEdit}
					blank={true}
					toggle={() => this.toggleEditModal({})}
					size="1048px"
				>
					<Edit
						toggle={() => this.toggleEditModal({})}
						contacto={this.state.contacto}
						getContactos={() => {
							const query = Object.keys(this.state.filtros ?? {}).map((fil) => {
								return `${fil}=${this.state.filtros[fil]}`;
							});

							this.getContactos("contactos?limit=20&" + query.join("&"));
						}}
					/>
				</Modal>
				<Modal
					title="Borrar Contacto"
					show={this.state.showDelete}
					callback={() => this.deleteContacto(itemActivo.id)}
					acceptText="Borrar"
					toggle={this.toggleDeleteModal}
				>
					¿Estás seguro de que deseas borrar este contacto?
				</Modal>
				<Modal
					show={this.state.showAsignarVendedor}
					blank={true}
					size="600px"
					toggle={this.toggleAsignarVendedorModal}
				>
					<AsignarVendedorForm
						toggle={this.toggleAsignarVendedorModal}
						seleccion={{ todos: seleccionarTodos, ids: seleccionados, total: totalFiltrados }}
						filtros={this.state.filtros ?? {}}
						onAsignado={this.onVendedorAsignado}
					/>
				</Modal>
				<Modal
                show={this.state.showEstadoDeCuentaModal}
                blank={true}
                size={"600px"}
                toggle={this.toggleEstadoDeCuentaModal}
            >
                <EstadosCuentaForm
                    toggle={() => {
                        this.toggleEstadoDeCuentaModal();
                    }}
                    numeraciones={this.state.numeraciones}
					clientes={itemActivo}
                />
            </Modal>
			</div>
		);
	}
}

export default withRouter(withRequest(Contactos));
